var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filteredstreams),function(stream){return _c('svg',{key:stream.streamnr,staticClass:"svgcont-trace",style:({display: _vm.displayStream(stream.streamnr), 
    background: _vm.bgcolor(stream.cl_init, stream.uni_di)}),attrs:{"height":_vm.svgheight}})}))}
var staticRenderFns = []

export { render, staticRenderFns }